// extracted by mini-css-extract-plugin
module.exports = {"item":"TabDiamondsType_item__7dpJd","btn":"TabDiamondsType_btn__eu0PC","iconTooltip":"TabDiamondsType_iconTooltip__VRP6H","container":"TabDiamondsType_container__KeDUW"};